import { Alert, Button, CardContent, CardHeader, CircularProgress, Stack, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { OneCard } from "lib/@components/one-card"
import { Case, CaseElse, Switch } from "lib/@components/switch"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { setFromEvent } from "lib/setFromEvent"
import { checkExisting } from "plugins/toolbox/client/controller/check-existing.controller"
import { CheckExistingTable } from "./check-existing-table"

const PANEL_IDLE = "idle"
const PANEL_RUNNING = "running"
const PANEL_EMPTY = "empty"
const PANEL_RESULTS = "results"

export function CheckExistingPanel() {
    const [description, setDescription] = useState("")
    const [running, setRunning] = useState(false)
    const [results, setResults] = useState(null)
    return (
        <OneCard>
            <CardHeader
                title="Check Existing"
                subheader="Finds FIQ tickets with descriptions similar to the text you enter."
                action={
                    <Button variant="contained" onClick={runCheck} disabled={running || !description.trim()}>
                        Check
                    </Button>
                }
            />
            <CardContent>
                <Stack spacing={3}>
                    <TextField
                        label="Description"
                        multiline
                        minRows={4}
                        fullWidth
                        value={description}
                        onChange={setFromEvent(setDescription)}
                    />
                    <Switch value={panelState()}>
                        <Case when={PANEL_RUNNING}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <CircularProgress size={20} />
                                <Typography variant="body2" color="text.secondary">
                                    Comparing against FIQ tickets.
                                </Typography>
                            </Stack>
                        </Case>
                        <Case when={PANEL_EMPTY}>
                            <Alert severity="success">No similar tickets found.</Alert>
                        </Case>
                        <Case when={PANEL_RESULTS}>
                            <CheckExistingTable results={results ?? []} />
                        </Case>
                        <CaseElse>
                            <Typography variant="body2" color="text.secondary">
                                Enter a defect description and run a check to see similar existing tickets.
                            </Typography>
                        </CaseElse>
                    </Switch>
                </Stack>
            </CardContent>
        </OneCard>
    )

    function panelState() {
        if (running) return PANEL_RUNNING
        if (!results) return PANEL_IDLE
        if (!results.length) return PANEL_EMPTY
        return PANEL_RESULTS
    }

    async function runCheck() {
        if (running) return

        setRunning(true)
        setResults(null)

        try {
            if (description.length < 2) return
            const found = await checkExisting({ input: description.trim(), limit: 5 })
            setResults(found ?? [])
        } catch (error) {
            errorSnackbar(`Check existing failed: ${error?.message ?? "unknown error"}`)
        } finally {
            setRunning(false)
        }
    }
}
